import clsx from 'clsx'
import {useEffect} from 'react'
import {ILayout, useLayout} from '../../core'
import {SidebarFooter} from './SidebarFooter'
import {SidebarLogo} from './SidebarLogo'
import {SidebarMenu} from './SidebarMenu'

// Body attributes the sidebar owns. They are removed on unmount so the auth pages (rendered
// outside MasterLayout) don't keep the sidebar's left offset after a logout.
const SIDEBAR_BODY_ATTRIBUTES = [
  'data-kt-app-sidebar-enabled',
  'data-kt-app-sidebar-fixed',
  'data-kt-app-sidebar-minimize',
  'data-kt-app-sidebar-hoverable',
  'data-kt-app-sidebar-push-header',
  'data-kt-app-sidebar-push-toolbar',
  'data-kt-app-sidebar-push-footer',
]

const Sidebar = () => {
  const {config} = useLayout()

  useEffect(() => {
    updateDOM(config)
    return () => SIDEBAR_BODY_ATTRIBUTES.forEach((attr) => document.body.removeAttribute(attr))
  }, [config])

  if (!config.app?.sidebar?.display) {
    return null
  }

  return (
    <div id='kt_app_sidebar' className={clsx('app-sidebar', config.app?.sidebar?.default?.class)}>
      <SidebarLogo />
      <SidebarMenu />
      <SidebarFooter />
    </div>
  )
}

const updateDOM = (config: ILayout) => {
  const sidebar = config.app?.sidebar?.default
  const body = document.body

  if (sidebar?.minimize?.desktop?.enabled) {
    if (sidebar.minimize.desktop.default) {
      body.setAttribute('data-kt-app-sidebar-minimize', 'on')
    }
    if (sidebar.minimize.desktop.hoverable) {
      body.setAttribute('data-kt-app-sidebar-hoverable', 'true')
    }
  }

  if (sidebar?.push?.header) body.setAttribute('data-kt-app-sidebar-push-header', 'true')
  if (sidebar?.push?.toolbar) body.setAttribute('data-kt-app-sidebar-push-toolbar', 'true')
  if (sidebar?.push?.footer) body.setAttribute('data-kt-app-sidebar-push-footer', 'true')

  body.setAttribute('data-kt-app-sidebar-enabled', 'true')
  body.setAttribute('data-kt-app-sidebar-fixed', sidebar?.fixed?.desktop?.toString() || '')

  // The drawer attributes (mobile slide-in) go on the sidebar element itself, after it renders.
  const drawer = sidebar?.drawer?.enabled ? sidebar.drawer.attributes || {} : {}
  setTimeout(() => {
    const sidebarElement = document.getElementById('kt_app_sidebar')
    if (!sidebarElement) return
    sidebarElement
      .getAttributeNames()
      .filter((t) => t.indexOf('data-') > -1)
      .forEach((attr) => sidebarElement.removeAttribute(attr))
    Object.entries(drawer).forEach(([key, value]) => sidebarElement.setAttribute(key, value))
  }, 0)
}

export {Sidebar}
